import { createHashRouter, Outlet, redirect } from 'react-router-dom';
import { HomePage } from 'src/modules/home/HomePage.tsx';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { UserInputPage } from 'src/modules/user-input/UserInputPage.tsx';
import { ValvesPage } from 'src/modules/valves/ValvesPage.tsx';
import { ActuatorsPage } from 'src/modules/actuators/ActuatorsPage.tsx';
import { PrefetchAccessories } from 'src/modules/accessories/PrefetchAccessories';
import { PrefetchValvesCheckout } from 'src/modules/checkout/PrefetchValvesCheckout.tsx';
import { SharePage } from 'src/modules/SharePage.tsx';
import { PATHS } from 'src/types/Paths';
import { createChildrenRoute } from 'src/projects/createChildrenRoute.tsx';
import { checkLocalState } from 'src/checkLocalState.ts';

const errorElement = <ErrorBoundary/>;

export const router = () => createHashRouter([
    {
        path: '/',
        loader: () => redirect(PATHS.Home),
    },
    {
        path: PATHS.Home,
        element: <Outlet/>,
        errorElement,
        children: createChildrenRoute(<HomePage/>),
    },
    {
        path: PATHS.UserInput,
        element: <Outlet/>,
        errorElement,
        children: createChildrenRoute(<UserInputPage/>),
        loader: () => checkLocalState(),
    },
    {
        path: `${PATHS.Valves}/:page`,
        element: <Outlet/>,
        errorElement,
        children: createChildrenRoute(<ValvesPage/>),
        loader: () => checkLocalState(),
    },
    {
        path: `${PATHS.Actuators}/:label/:page`,
        element: <Outlet/>,
        errorElement,
        children: createChildrenRoute(<ActuatorsPage/>),
        loader: () => checkLocalState(),
    },
    {
        path: `${PATHS.Accessories}/:valveLabel/:actuatorLabel/:page`,
        element: <Outlet/>,
        errorElement,
        children: createChildrenRoute(<PrefetchAccessories/>),
        loader: () => checkLocalState(),
    },
    {
        path: `${PATHS.Checkout}/:valveLabel/:actuatorLabel/:page`,
        element: <Outlet/>,
        errorElement,
        children: createChildrenRoute(<PrefetchValvesCheckout/>),
        loader: () => checkLocalState(),
    },
    {
        path: PATHS.Share,
        element: <SharePage/>,
        errorElement,
    },
    {
        path: '*',
        loader: () => redirect(PATHS.Home),
    },
]);
